"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplateBodyCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const StyledPaper = (0, styled_components_1.default)(core_1.Paper) `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  .MuiTableContainer-root {
    flex: 1;
    overflow: auto;
  }
  ${props => props.theme.breakpoints.down('sm')} {
    border-radius: 0;
  }
`;
const PageTemplateBodyCard = props => {
    const { children } = props;
    return (react_1.default.createElement(StyledPaper, { elevation: 2, className: 'page-template-body' }, children));
};
exports.PageTemplateBodyCard = PageTemplateBodyCard;
exports.default = exports.PageTemplateBodyCard;
//# sourceMappingURL=PageTemplateBodyCard.js.map